import React from 'react';

/**
 * Renders a copy string where phrases wrapped in **double asterisks** are
 * emphasised in the brand green, mirroring the highlighted phrases used in
 * long-form advertorial copy.
 */
export function renderRich(text: string): React.ReactNode[] {
  return text.split('**').map((chunk, index) => index % 2 === 1 ? <span key={index} className="font-medium text-brand-600" data-id="element-76" data-mp="2kza4w71llims">
        {chunk}
      </span> : <React.Fragment key={index} data-id="element-77" data-mp="2fyvw2ms6a4np">{chunk}</React.Fragment>);
}